const styles = theme => ({
  hashtagContainer: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.alt.main,
    padding: theme.spacing(1),
    height: "auto"
  },
  add: {
    width: 30,
    height: 30
  },
  addDisabled: {
    color: "#A0A0A0"
  },
  labelSmallExtra: {
    maxWidth: 200,
    whiteSpace: "normal",
    textOverflow: "unset",
    wordBreak: "break-word"
  },
  hashtagTitle: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Hashtags/styles.js